import { Component, OnInit } from '@angular/core';
import * as alertify from 'alertifyjs'
import { AuthService } from './services/auth/auth.service';
import { NavbarService } from './services/navbar-service/navbar.service';
import { ThemeService } from './services/theme-service/theme.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'smart-lga';

  user: any;
  isFullPageView: boolean = false;
  fullPageRoutes = ['/404', '/401']

  constructor(private authService: AuthService, private navbarService: NavbarService, private themeService: ThemeService, private router: Router) {

  }

  isSideNavOpen: boolean;



  ngOnInit(): void {
    alertify.set("notifier", "position", "top-center");

    this.authService.user$.subscribe((user: any) => {
      this.user = user;
    });

    this.navbarService.getSidebarState().subscribe((isSideNavOpen: boolean) => {
      this.isSideNavOpen = isSideNavOpen;
    });


    this.subscribeToRouteChanges()

  }

  subscribeToRouteChanges() {
    this.router.events.subscribe(event => {

      const currentPath = this.router.url.split('?')[0];
  
      if (this.fullPageRoutes.includes(currentPath)) {
        this.isFullPageView = true
      }
      else {
        this.isFullPageView = false

      }
    })
  }


  closeSideBar() {
    this.navbarService.closeSidebar()
  }
}
